import PropTypes from 'prop-types';

/**
 * Obtiene el color según el porcentaje de match
 * @param {number} porcentaje - Porcentaje de match (0-100)
 * @returns {Object} Objeto con clases de color para texto y fondo
 */
const getColorByPercentage = (porcentaje) => {
    if (porcentaje === 100) {
        return {
            textColor: 'text-success-20',
            bgColor: 'bg-success-50',
            borderColor: 'border-success-30',
        };
    } else if (porcentaje >= 80.01 && porcentaje <= 99.99) {
        return {
            textColor: 'text-warning-10',
            bgColor: 'bg-warning-40',
            borderColor: 'border-[#996900]',
        };
    } else {
        return {
            textColor: 'text-error-20',
            bgColor: 'bg-error-50',
            borderColor: 'border-error-30',
        };
    }
};

/**
 * Componente para renderizar el porcentaje de match con color
 * Rojo: 0-80%, Amarillo: 81-99%, Verde: 100%
 *
 * @param {Object} props - Props del componente
 * @param {number} props.value - Valor del porcentaje
 */
export const PorcentajeMatch = ({ value }) => {
    const porcentaje = value ?? 0;
    const { textColor, bgColor, borderColor } = getColorByPercentage(porcentaje);

    return (
        <div className="flex items-center justify-center w-full h-full">
            <span
                className={`
          inline-flex items-center justify-center
          px-2 py-1 rounded
          typography-b3 font-semibold
          ${textColor} ${bgColor} ${borderColor}
          border
          min-w-[60px]
        `}
            >
                {porcentaje}%
            </span>
        </div>
    );
};

PorcentajeMatch.propTypes = {
    value: PropTypes.number,
};

export default PorcentajeMatch;
